
	document.addEventListener("DOMContentLoaded", function() {
	// Hole die aktuelle Sprache von WPML
	let lang = document.documentElement.lang || 'de-DE'; // Standard: Deutsch
		console.log(lang);

	// Übersetzungen für das Order Notes-Feld
	const translations = {
	'de-DE': {
	'order_notes_label': 'Anmerkung zur Bestellung',
	'order_notes_placeholder': 'Bemerkungen? Oder wünschen Sie einen Beleg per E-Mail? Dann geben Sie uns hier Ihre E-Mail-Adresse an.',
	'checkbox_label': 'Ich möchte gerne exklusive E-Mails mit Rabatten und Produktinformationen erhalten.'
},
	'fr-FR': {
	'order_notes_label': 'Remarques sur la commande',
	'order_notes_placeholder': 'Vous avez des remarques ? Ou souhaitez-vous recevoir un justificatif par e-mail ? Dans ce cas, indiquez-nous ici votre adresse e-mail.',
	'checkbox_label': 'Je souhaite recevoir des e-mails exclusifs avec des rabais et des informations sur les produits.'
}
};

// MutationObserver für dynamisches WooCommerce-Checkout-Feld
		const observer = new MutationObserver((mutations, obs) => {
			// Order Notes Feld
			let orderNotesField = document.querySelector('textarea[name="order_comments"]');
			if (orderNotesField) {
				orderNotesField.setAttribute("placeholder", translations[lang]?.order_notes_placeholder || translations['de-DE'].order_notes_placeholder);

				let label = document.querySelector('label[for="order_comments"]');
				if (label) {
					label.textContent = translations[lang]?.order_notes_label || translations['de-DE'].order_notes_label;
				}
			}

			// Checkbox Label
			let checkboxLabel = document.querySelector('label[for="mailpoet_woocommerce_checkout_optin"] span');
			if (!checkboxLabel) {
				checkboxLabel = document.querySelector('[data-automation-id="woo-commerce-subscription-opt-in"] span'); // Alternative Suche nach dem Label
			}
			if (checkboxLabel) {
				checkboxLabel.textContent = translations[lang]?.checkbox_label || translations['de-DE'].checkbox_label;
			}

			// Falls beide Felder gefunden wurden, Observer deaktivieren
			if (orderNotesField && checkboxLabel) {
				obs.disconnect();
			}
		});

		// Überwacht den Body für Änderungen, falls WooCommerce Blocks die Felder nachlädt
		observer.observe(document.body, { childList: true, subtree: true });
	});
